
const CustomSelect = ({
  label,
  name,
  value,
  onChange,
  options,
  error,
  placeholder = "Select an option",
  required = false,
  id,
  optionLabelKey = "label", // key name for label
  optionValueKey = "value", // key name for value
}) => {
  return (
    <div className="custom-select-wrapper">
      {label && (
        <label htmlFor={id || name} className="form-label">
          {label} {required && <span className="text-danger">*</span>}
        </label>
      )}

      <select
        id={id || name}
        name={name}
        value={value}
        onChange={onChange}
        className={`form-select ${error ? "is-invalid" : ""}`}
        style={{
          height: "48px",
          borderRadius: "13px",
          cursor: "pointer",
          padding: "0 12px",
        }}
      >
        <option value="">{placeholder}</option>
        {options?.map((opt) => (
          <option key={opt.id} value={opt[optionValueKey]}>
            {opt[optionLabelKey]}
          </option>
        ))}
      </select>

      {error && <div className="invalid-feedback">{error}</div>}
    </div>
  );
};

export default CustomSelect;
